/* DIREVULF — account page behaviour (assets/dv-profile.js).

   Signed in with KwikPass (mobile OTP): the page asks DVAccount (assets/
   dv-kp-session.js) for the account — verified with GoKwik by the profile
   API — and draws it: name card + menu on the left, orders / addresses /
   details on the right. Signed out: the login card, whose button opens the
   KwikPass OTP popup. Nothing here touches Shopify's own sign-in. */
(function () {
  'use strict';
  var root = document.querySelector('[data-dva]');
  if (!root) return;
  var RETURN = '/pages/profile';
  var app = root.querySelector('[data-dva-app]');

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(m) {
    if (!m) return '';
    try {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: m.currency || 'INR' }).format(Number(m.amount));
    } catch (e) { return (m.currency === 'INR' ? '₹' : '') + m.amount; }
  }
  function date(iso) {
    try { return new Date(iso).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ (\d{4})$/, ', $1'); }
    catch (e) { return ''; }
  }
  var CHEV = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';

  /* ---------- sign in: open the KwikPass OTP popup ----------
     KwikPass's own helper (handleKpAndShopifyLogin) adds a Shopify sign-in
     step, so the popup is opened directly instead. */
  function kwikReady() {
    return typeof window.handleKpAndShopifyLogin === 'function' || typeof window.handleLogout === 'function';
  }
  function kwikLogin() {
    if (!kwikReady()) return false;
    try { sessionStorage.removeItem('isLogout'); } catch (e) {}
    /* A plain KwikPass login: no Shopify sign-in step. With Shopify's new
       customer accounts that step asks the shopper for their email and then
       sends them to Shopify's own Orders page, which this store does not use. */
    window.dispatchEvent(new CustomEvent('open_login_modal', {
      detail: { customLogin: false, params: {} }
    }));
    watchLogin();
    return true;
  }
  var watching = null;
  function watchLogin() {
    if (watching) return;
    var before = window.DVAccount ? window.DVAccount.token() : '';
    var n = 0;
    watching = setInterval(function () {
      n++;
      var now = window.DVAccount ? window.DVAccount.token() : '';
      if (now && now !== before) { clearInterval(watching); watching = null; signedIn(); }
      else if (n > 400) { clearInterval(watching); watching = null; } // ~10 min
    }, 1500);
  }
  function signedIn() {
    if (!app) { location.reload(); return; }
    if (window.DVAccount) window.DVAccount.clear();
    start(true);
  }
  window.addEventListener('user-loggedin', function () {
    if (!watching) return; // only after the visitor started a login here
    clearInterval(watching); watching = null;
    setTimeout(signedIn, 400);
  });
  function bindLogin(scope) {
    var btn = scope.querySelector('[data-dva-login]');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (kwikLogin()) return;
      var tries = 0;
      var t = setInterval(function () {
        tries++;
        if (kwikLogin() || tries > 40) clearInterval(t);
      }, 150);
    });
  }

  /* ---------- views ---------- */
  function status(o) {
    if (o.cancelled) return ['cancelled', 'Cancelled'];
    if (o.delivered) return ['delivered', 'Delivered'];
    if (o.fulfillment === 'FULFILLED' || o.fulfillment === 'PARTIALLY_FULFILLED') return ['shipped', 'Shipped'];
    return ['placed', o.financial === 'PENDING' ? 'Order confirmed' : 'Order placed'];
  }
  function orderCard(o) {
    var st = status(o);
    var items = (o.items || []).map(function (li) {
      var title = li.handle ? '<a class="dva-item__title" href="/products/' + esc(li.handle) + '">' + esc(li.title) + '</a>' : '<p class="dva-item__title">' + esc(li.title) + '</p>';
      return '<div class="dva-item">' +
        '<div class="dva-item__img">' + (li.image ? '<img src="' + esc(li.image) + '" alt="' + esc(li.title) + '" loading="lazy" width="112" height="140">' : '') + '</div>' +
        '<div class="dva-item__info">' + title +
          '<p class="dva-muted">' + (li.variant ? 'Size: ' + esc(li.variant) + ' &nbsp;|&nbsp; ' : '') + 'Qty: ' + esc(li.quantity) + '</p>' +
          '<p class="dva-status dva-status--' + st[0] + '">' + st[1] + '</p>' +
          (o.trackingUrl && !o.cancelled ? '<a class="dva-track" href="' + esc(o.trackingUrl) + '" target="_blank" rel="noopener">Track</a>' : '') +
        '</div>' +
        '<p class="dva-item__price">' + money(li.price) + '</p>' +
      '</div>';
    }).join('');
    var n = (o.items || []).length;
    return '<article class="dva-order">' +
      '<header class="dva-order__head"><p>Order ID : <b>' + esc(String(o.name).replace('#', '')) + '</b></p>' +
        '<p class="dva-order__date">' + date(o.createdAt) + '</p>' +
        (o.statusUrl ? '<a class="dva-link" href="' + esc(o.statusUrl) + '">Details</a>' : '') + '</header>' +
      items +
      '<footer class="dva-order__foot"><span class="dva-muted">' + n + ' item' + (n === 1 ? '' : 's') + '</span><span>Total <b>' + money(o.total) + '</b></span></footer>' +
    '</article>';
  }
  function ordersPanel(me) {
    var body;
    if (!me.ordersAvailable) {
      body = '<div class="dva-empty"><p class="dva-empty__h">Orders are being connected</p><p>Your orders will appear here shortly. Meanwhile you can <a class="dva-link" href="/pages/track-order">track an order</a>.</p></div>';
    } else if (!me.orders || !me.orders.length) {
      body = '<div class="dva-empty"><p class="dva-empty__h">No orders yet</p><p>When you place an order, it will show up here.</p><a class="dva-btn" href="/collections/all">Start shopping</a></div>';
    } else {
      body = '<div class="dva-orders">' + me.orders.map(orderCard).join('') + '</div>';
    }
    return '<div class="dva-panel" data-dva-panel="orders"><h1 class="dva-title">My Orders</h1>' + body + '</div>';
  }
  function addressesPanel(me) {
    var list = me.addresses || [];
    var body = !list.length
      ? '<div class="dva-empty"><p class="dva-empty__h">No saved addresses</p><p>Your address is saved automatically when you place an order.</p></div>'
      : '<div class="dva-addrs">' + list.map(function (a) {
          return '<div class="dva-addr">' +
            '<p class="dva-addr__name">' + esc([a.firstName, a.lastName].filter(Boolean).join(' ')) + (a.isDefault ? '<span class="dva-badge">Default</span>' : '') + '</p>' +
            '<p>' + esc(a.address1) + (a.address2 ? ', ' + esc(a.address2) : '') + '</p>' +
            '<p>' + esc(a.city) + (a.province ? ', ' + esc(a.province) : '') + ' ' + esc(a.zip) + '</p>' +
            '<p>' + esc(a.country) + '</p>' +
            (a.phone ? '<p class="dva-muted">' + esc(a.phone) + '</p>' : '') +
          '</div>';
        }).join('') + '</div>';
    return '<div class="dva-panel" data-dva-panel="addresses" hidden><h1 class="dva-title">Saved Addresses</h1>' + body + '</div>';
  }
  function detailsPanel(me) {
    function row(k, v) { return '<div><dt>' + k + '</dt><dd>' + (v ? esc(v) : '—') + '</dd></div>'; }
    return '<div class="dva-panel" data-dva-panel="details" hidden><h1 class="dva-title">Account Details</h1>' +
      '<dl class="dva-details">' + row('Name', me.name) + row('Mobile', me.phone) + row('Email', me.email) + row('Orders', String(me.ordersCount || (me.orders || []).length)) + '</dl></div>';
  }
  function renderAccount(me) {
    var name = me.name || me.phone || 'Member';
    var contact = [me.email, me.phone].filter(Boolean).join(' · ');
    app.innerHTML =
      '<div class="dva-wrap">' +
        '<aside class="dva-side">' +
          '<div class="dva-me"><p class="dva-me__name">' + esc(name) + '</p>' + (contact ? '<p class="dva-me__contact">' + esc(contact) + '</p>' : '') + '<p class="dva-me__tag">Pack member</p></div>' +
          '<nav class="dva-menu" aria-label="Account">' +
            '<button type="button" class="dva-menu__item" data-dva-tab="orders"><span>Orders</span><small>Track your order here</small></button>' +
            '<button type="button" class="dva-menu__item" data-dva-tab="addresses"><span>Saved Addresses</span>' + CHEV + '</button>' +
            '<button type="button" class="dva-menu__item" data-dva-tab="details"><span>Account Details</span>' + CHEV + '</button>' +
            '<a class="dva-menu__item" href="/pages/track-order"><span>Track an Order</span>' + CHEV + '</a>' +
            '<a class="dva-menu__item" href="/pages/faq"><span>FAQs</span>' + CHEV + '</a>' +
            '<a class="dva-menu__item" href="/pages/contact"><span>Help &amp; Support</span>' + CHEV + '</a>' +
          '</nav>' +
          '<a class="dva-logout" href="' + RETURN + '" data-dva-logout>Logout</a>' +
        '</aside>' +
        '<div class="dva-main">' + ordersPanel(me) + addressesPanel(me) + detailsPanel(me) + '</div>' +
      '</div>';
    bindTabs();
    bindLogout();
    try { window.dispatchEvent(new CustomEvent('dv:account', { detail: me })); } catch (e) {}
  }
  function renderOut() {
    var tpl = root.querySelector('template[data-dva-out]');
    app.innerHTML = tpl ? tpl.innerHTML : '';
    bindLogin(app);
  }
  function renderError() {
    app.innerHTML = '<div class="dva-out"><div class="dva-out__card"><h1 class="dva-title">My Account</h1>' +
      '<p class="dva-muted">We couldn’t load your account just now.</p>' +
      '<button type="button" class="dva-btn dva-btn--block" data-dva-retry>Try again</button></div></div>';
    app.querySelector('[data-dva-retry]').addEventListener('click', function () { start(true); });
  }

  /* ---------- menu panels ---------- */
  function bindTabs() {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-dva-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-dva-panel]'));
    function show(name, scroll) {
      if (!panels.some(function (p) { return p.getAttribute('data-dva-panel') === name; })) name = 'orders';
      panels.forEach(function (p) { p.hidden = p.getAttribute('data-dva-panel') !== name; });
      tabs.forEach(function (t) { t.setAttribute('aria-current', t.getAttribute('data-dva-tab') === name ? 'true' : 'false'); });
      try { history.replaceState(null, '', '#' + name); } catch (e) {}
      if (scroll && window.innerWidth < 900) {
        var main = root.querySelector('.dva-main');
        if (main) main.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-dva-tab'), true); }); });
    if (tabs.length) show((location.hash || '').replace('#', '') || 'orders', false);
  }

  /* ---------- logout: end the KwikPass session ---------- */
  function bindLogout() {
    var a = root.querySelector('[data-dva-logout]');
    if (!a) return;
    a.addEventListener('click', function (e) {
      if (window.DVAccount) window.DVAccount.clear();
      try { if (typeof window.handleLogout === 'function') window.handleLogout(); } catch (err) {}
      if (!app) return; // Shopify session: let the link log out of Shopify too
      e.preventDefault();
      try { sessionStorage.setItem('isLogout', 'true'); } catch (err) {}
      setTimeout(function () { location.href = '/'; }, 400);
    });
  }

  /* ---------- start ---------- */
  function start(fresh) {
    if (!app) { bindTabs(); bindLogout(); return; } // Shopify-session render (Liquid) — nothing to fetch
    var acct = window.DVAccount;
    if (!acct || !acct.token()) { renderOut(); return; }
    app.innerHTML = '<div class="dva-loading" aria-live="polite"><span class="dva-spin"></span>Loading your account…</div>';
    acct.load(fresh).then(function (me) { if (me) renderAccount(me); else renderOut(); }, renderError);
  }
  if (window.DVAccount || !app) start(false);
  else document.addEventListener('DOMContentLoaded', function () { start(false); });
})();
